import React from 'react';
/** Should the inputs below this provider display:
 *  - '* Required'
 *  - or '*' */ export const RequiredTextContext = /*#__PURE__*/ React.createContext(true);
